import React, { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import VideoTrack from '../../../base/media/components/web/VideoTrack';
import { ROLE, checkRoleLevel, getDisplayNickname, getLocalMemberRole } from '../../../base/members';
import { useSelector } from 'react-redux';
import { getDisplayName, getPropertyValue } from '../../../base/settings';
import { toggleLoad } from '../../../base/loading';
const MemberVideo = React.memo(({ videoTrack, nickname, isFullScreen = false, role, handlerFullScreen, handlerExitFullScreen, }) => {
    const dispatch = useDispatch();
    const display_name = useSelector((state) => getDisplayName(state));
    const local_role = useSelector((state) => getLocalMemberRole(state));
    const individualLive = useSelector((state) => getPropertyValue(state, 'individualLive'));
    // useEffect(() => {
    // 	console.log('MemberVideo useEffect', videoTrack);
    // 	setMuted(!videoTrack || videoTrack.muted);
    // }, [videoTrack]);
    const muted = !videoTrack || videoTrack.muted;
    useEffect(() => {
        if (!muted) {
            dispatch(toggleLoad(false));
        }
        ;
    }, [muted]);
    const renderMutedVideo = useMemo(() => {
        return (React.createElement("div", { className: "default" },
            React.createElement("div", { className: "circleText" },
                React.createElement("div", { className: " overText" }, getDisplayNickname(nickname, role)))));
    }, [nickname, role]);
    const isLocalStudent = useMemo(() => !checkRoleLevel(local_role, ROLE.MANAGER), [local_role]);
    const isTeacher = useMemo(() => checkRoleLevel(role, ROLE.MANAGER), [role]);
    // 타일 소유자가 "다른 학생"(핀/손들기 수락 카메라)인지 — role 미지정(화면공유 타일)은 제외.
    // 이 타일의 첫 프레임 지연은 상대 기기 카메라 재획득 문제라 전역 로딩/전체 재접속 대상이 아니다.
    const isPeerStudentTile = useMemo(() => role !== undefined && !checkRoleLevel(role, ROLE.MANAGER), [role]);
    return muted ? (renderMutedVideo) : (React.createElement(VideoTrack, { isLocalStudent: isLocalStudent, isPeerStudentTile: isPeerStudentTile, className: "member_video", videoTrack: videoTrack, isFullScreen: individualLive ? false : isFullScreen, muted: false, showWaterMark: isLocalStudent && isTeacher, nickname: display_name, handlerFullScreen: handlerFullScreen, handlerExitFullScreen: handlerExitFullScreen }));
});
export default MemberVideo;
